function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Question Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.9653,0.5 C15.1843,0.5 19.4303,4.746 19.4303,9.965 C19.4303,15.184 15.1843,19.43 9.9653,19.43 C4.7463,19.43 0.5003,15.184 0.5003,9.965 C0.5003,4.746 4.7463,0.5 9.9653,0.5 Z M9.9653,1.5 C5.2973,1.5 1.5003,5.297 1.5003,9.965 C1.5003,14.633 5.2973,18.43 9.9653,18.43 C14.6323,18.43 18.4303,14.633 18.4303,9.965 C18.4303,5.297 14.6323,1.5 9.9653,1.5 Z M9.9351,14.2161 C10.3491,14.2161 10.6851,14.5521 10.6851,14.9661 C10.6851,15.3801 10.3491,15.7261 9.9351,15.7261 C9.5211,15.7261 9.1751,15.3901 9.1751,14.9761 C9.1751,14.5621 9.5111,14.2161 9.9251,14.2161 L9.9351,14.2161 Z M9.9302,4.4544 C11.7482,4.4544 13.2272,5.9334 13.2272,7.7514 C13.2272,9.0814 12.3052,9.7684 11.5652,10.3194 C10.8622,10.8444 10.4302,11.1974 10.4302,11.8194 C10.4302,12.0954 10.2062,12.3194 9.9302,12.3194 C9.6542,12.3194 9.4302,12.0954 9.4302,11.8194 C9.4302,10.6634 10.2472,10.0554 10.9682,9.5184 C11.6432,9.0144 12.2272,8.5794 12.2272,7.7514 C12.2272,6.4844 11.1972,5.4544 9.9302,5.4544 C8.6632,5.4544 7.6332,6.4844 7.6332,7.7514 C7.6332,8.0274 7.4092,8.2514 7.1332,8.2514 C6.8572,8.2514 6.6332,8.0274 6.6332,7.7514 C6.6332,5.9334 8.1122,4.4544 9.9302,4.4544 Z",
  id: "question-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "question-Icon/Global/question",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "question-Swatches/DarkGreen",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "question-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#question-path-1"
})));

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.495110a0.svg";
export { ForwardRef as ReactComponent };